import { atom, RecoilState, selector } from "recoil";
import {  AgeRange, Gender, ProductInfo, TLocation } from "ztypes/common";
import { CampaignInfo } from "ztypes/campaign-info";

export const zoomState: RecoilState<number> = atom({
  key: "zoomState",
  default: 1,
});

export const campaignInfoState: RecoilState<CampaignInfo> = atom({
  key: "campaignInfoState",
  default: {
    fid: 0,
    adsId: "",
    totalCost: ProductInfo.VIEW_8K.price,
    packageId: ProductInfo.VIEW_8K.id,
    campaignDuration: 1,
    gender: [Gender.ALL],
    ageRange: [AgeRange.AGE_ALL],
    location: [TLocation.ALL],
  } as CampaignInfo,
});

export const isCompletedState: RecoilState<boolean> = atom({
  key: "isCompletedState",
  default: true,
});

export const bottomSheetModalState: RecoilState<boolean> = atom({
  key: "bottomSheetModalState",
  default: false,
});


